import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get PpeComplilance
export const getPricelist = createAsyncThunk("/getlist-price-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-price-list`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log({ response });
    return response;
  } catch (error) {
    console.error("Error fetching PpeComplilance- ", error);
    throw error;
  }
});

// get count of price list
export const getCountPriceList = createAsyncThunk("/getcount-price-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getcount-price-list`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log({ response });
    return response;
  } catch (error) {
    console.error("Error fetching PpeComplilance- ", error);
    throw error;
  }
});
